import { clsx } from 'clsx'
import {
  type ComponentPropsWithoutRef,
  type FC,
  type PropsWithChildren,
} from 'react'

type ProductHeadGenericLinkLabelProps = ComponentPropsWithoutRef<'a'>

export const ProductHeadGenericLinkLabel: FC<
  PropsWithChildren<ProductHeadGenericLinkLabelProps>
> = ({ children, className, ...rest }) => (
  <a
    className={clsx(
      className,
      'mb-2.5 mr-2.5 flex cursor-pointer items-center rounded-full border px-2 py-1 text-xs',
    )}
    {...rest}
  >
    {children}
  </a>
)
